import "../App.css";
function Loading1() {
  return (
    <div className="flex justify-center items-center bg-slate-900 w-full">
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Loading1;
